import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useTranslation } from 'react-i18next';
import { getNumberOfPages, getPageFromQuery, locationWithPageNumber } from 'utils/pagination';
import { useFetchMyUpcomingContent, PROFILE_ITEMS_PER_PAGE } from 'actions/content';
import Box from 'components/Box';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Pagination from 'components/Pagination';
import Stack from 'components/Stack';
import HeadingWithFilters from 'components/HeadingWithFilters';
import ContentTypeFilter from '../ContentTypeFilter';
import ItemsGrid from '../ItemsGrid';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Upcoming() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var type = queryParams.type;
  var page = getPageFromQuery({
    query: queryParams
  });
  var _useFetchMyUpcomingCo = useFetchMyUpcomingContent({
      type: type,
      page: page
    }),
    upcoming = _useFetchMyUpcomingCo.items,
    isLoading = _useFetchMyUpcomingCo.isLoading,
    isError = _useFetchMyUpcomingCo.isError,
    total = _useFetchMyUpcomingCo.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: PROFILE_ITEMS_PER_PAGE
  });
  var hasFilters = type && type !== 'all';
  var upcomingEmptyContent = hasFilters ? t('error_no_filter_results') : t('empty_no_upcoming');
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(HeadingWithFilters, {
      heading: /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('upcoming_title')
      }),
      children: /*#__PURE__*/_jsx(ContentTypeFilter, {})
    }), /*#__PURE__*/_jsx(Stack, {
      spacing: "l",
      children: /*#__PURE__*/_jsx("section", {
        "aria-label": t('upcoming_title'),
        children: /*#__PURE__*/_jsx(ItemsGrid, {
          items: upcoming,
          isError: isError,
          isLoading: isLoading,
          emptyContent: upcomingEmptyContent,
          priorityPillTypeOrder: ['event', 'goal']
        })
      })
    }), pageCount > 1 && /*#__PURE__*/_jsx(Box, {
      mt: "m",
      children: /*#__PURE__*/_jsx(Pagination, {
        pageCount: pageCount,
        currentPage: page,
        getPageLink: function getPageLink(pageNumber) {
          return locationWithPageNumber({
            location: location,
            page: pageNumber
          });
        }
      })
    })]
  });
}
export default Upcoming;